var _a;
import { Map } from 'immutable';
import { LOADING_APP, UPDATE_AUTH_TOKEN, UPDATE_SADMIN, } from "../actions/app";
var authToken = localStorage.getItem('authToken');
var initialState = Map({
    loadingApp: true,
    auth_token: authToken,
    is_sadmin: false,
});
var actionsMap = (_a = {},
    _a[LOADING_APP] = function (state, action) {
        return state.merge(Map({
            auth_token: action.payload,
        }));
    },
    _a[UPDATE_AUTH_TOKEN] = function (state, action) {
        return state.merge(Map({
            auth_token: action.payload,
        }));
    },
    _a[UPDATE_SADMIN] = function (state, action) {
        return state.merge(Map({
            is_sadmin: action.payload,
        }));
    },
    _a);
export default function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    var fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}



//////////////////
// WEBPACK FOOTER
// ./src/reducers/app.ts
// module id = 270
// module chunks = 0